import { lazyGroup } from '../../shell/lazyGroup';

/**
 * 🔨 The asset register's node form, loaded when a window first opens it and never with the page that offers it
 * (piece 12; decisions 10641, 10643). Add New and a bill's line both open it, so the one wrapper is written here.
 */
export const NodeFormModal = lazyGroup(() => import('../assets/AssetModals'))('NodeFormModal');
